<template>

<div>

  <app-header />


  <div class="container">

      <div class="my-3">
        <h1>{{project.name}}</h1>
        <!-- <p class="text-muted"><a :href="url(project.slug)" target="_blank">{{ url(project.slug) }}</a></p> -->
      </div>

      <div class="d-flex align-content-center justify-content-between mb-3">
      	<h3>{{_lang('Form Submission History')}}</h3>
				<div class="d-flex">

      	<button class="btn btn-warning" @click="modalSettings=true">{{_lang('Settings')}}</button>
      	<button class="btn btn-primary" @click="modalIntegration=true">{{_lang('Integrations')}}</button>
				</div>
      </div>

			<div v-if="selected.length && history.length>10" class="form-group text-right">
      	<label class="mr-2">{{ _lang('With selected:') }}</label>
      	<button class="btn btn-danger btn-sm" @click="deleteSelected">{{ _lang('Delete') }}</button>
      </div>

			<div class="table-responsive">
	      <table class="table table-hover">
	      	<thead>
	      		<th>{{ _lang('Sent') }}</th>
	      		<th>{{ _lang('Data submitted') }}</th>
	      		<th></th>
	      	</thead>
	      	<tbody>
	    			<tr v-for="row in history">
		          <td>
		          	<strong>{{row.created_at}}</strong><br>
		          	<a class="url" v-if="row.url.match(/^http?s:\/\//)" :href="cleanUrl(row.url)" target="_blank">{{row.url}}</a>
		          	<span class="url" v-else>{{row.url}}</span>
		          	<br>
		          	<strong class="text-capitalized">{{ row.submit }}</strong>: {{row.to}}<br>
				        <span v-if="row.subject"><strong>{{ _lang('Subject') }}:</strong> {{row.subject}}</span>
				      </td>
	          	<td><div class="text" v-html="row.data"></div></td>
	          	<td><input type="checkbox" v-model="selected" :value="row.id"></td>
	    			</tr>
	      	</tbody>
	      </table>
	    </div>

			<div v-if="selected.length" class="form-group text-right">
      	<label class="mr-2">{{ _lang('With selected:') }}</label>
      	<button class="btn btn-danger btn-sm" @click="deleteSelected">{{ _lang('Delete') }}</button>
      </div>

    </div>


    <div v-if="modalIntegration" class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{_lang('Integrations')}}</div>
             <span class="close" @click="modalIntegration=false">&times;</span>
          </div>

           <div class="modal-body">

               <div class="form-group">
               		<p>{{_lang('Copy the following code and paste it to a') }} <a href="https://sheets.new" target="_blank">{{ _lang('new spreadsheet') }}</a>.</p>
										<p>
											<label><input type="checkbox" v-model="integrationOptions.includePhone"> {{_lang('Include phone number column')}}</label><br>
											<label><input type="checkbox" v-model="integrationOptions.includeGTags"> {{_lang('Include link parameters column')}}</label>
										</p>

	                <dl>
	                    <dt>{{_lang('Code')}}</dt>
	                    <dd><textarea readonly class="form-control">{{ gsheetsCode }}</textarea></dd>
	                </dl>
               </div>


           </div>
         </div>
       </div>
    </div>

    <div v-if="modalSettings" class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{_lang('Settings')}}</div>
             <span class="close" @click="modalSettings=false">&times;</span>
          </div>

          <form class="modal-body" @submit="onSubmitSettings">

						<div class="form-group">
							<p>{{_lang('Ordering') }}</p>
							<select v-model="data.formHistoryOrderBy" class="form-control">
								<option value="created_at">Mais antigos</option>
								<option value="-created_at">Mais recentes</option>
							</select>
						</div>

						<button class="btn btn-primary" type="submit">{{ _lang('Save') }}</button>

          </form>
        </div>
      </div>
    </div>



</div>

</template>
<script>

import axios from 'axios';
import appHeader from '../components/appHeader.vue'

export default {
  name: 'form-history',
  props:['project_id'],
  components:{
    appHeader,
  },
  data() {
    return {
      project:{},
      history:[],
			data:{
				formHistoryOrderBy:'created_at',
			},
      modalIntegration:false,
			integrationOptions:{
				includePhone:true,
				includeGTags:true,
			},
      modalSettings:false,
			selected:[],
    }
  },
  computed:{
      gsheetsCode(){
      	if(!this.project.id) return '';
				let url = `${process.env.VUE_APP_PROTOCOL}://app.${process.env.VUE_APP_BASEURL}/google-sheets/${this.project.id}/${this.project.token}`;
				const quryParams = [];
				if(this.integrationOptions.includePhone) quryParams.push('phone=1');
				if(this.integrationOptions.includeGTags) quryParams.push('gtags=1');
				if(quryParams.length) url += `?${quryParams.join('&')}`;

      	return '=IMPORTHTML("'+url+'"; "table"; 1)';
      }

  },
  methods:{
  	deleteSelected(){
  		if(!confirm(this._lang('Delete all selected entries?'))) return;

  		axios({
        method: 'delete',
        url: `/api/projects/${this.project.id}/form-history`,
        data: {selected:this.selected}
      }).then((res) => {
				this.selected = [];
        this.getHistory();
        toastr(this._lang('Selected entries successfully deleted.','Ok','#00cc00'));
      });
  	},
  	cleanUrl(url){
  		return url.replace(/\?.*/,'',url);
  	},
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },

    getHistory(){
      axios({
        url: '/api/projects/'+this.project_id+'/form-history',
      }).then((res) => {
        this.project = res.data.project;
				if(this.project.meta && this.project.meta.formHistoryOrderBy){
					this.data.formHistoryOrderBy = this.project.meta.formHistoryOrderBy;
				}
        this.history = res.data.history;
      });
    },

		onSubmitSettings(e){
			e.preventDefault();

			axios.post('/api/projects/'+this.project.id+'/settings',this.data).then(()=>{
				this.modalSettings = false;
    		this.getHistory();
			})
		}

  },
  mounted(){
    this.getHistory();
  }

}



</script>

<style scoped>
.text { white-space: pre-wrap; }
.text-capitalized {text-transform: capitalize;}
.url {
	max-width: 400px;
	/* overflow: hidden; */
	display: inline-block;
	/* white-space: nowrap; */
	/* text-overflow: ellipsis; */
	word-break: break-word;
}
</style>
